'use client';

import { cn } from '@/lib/utils';

import { useHeaderStore } from './stores/header-store-provider';

export default function HeaderStickyWrapper({ children }: { children: React.ReactNode }) {
    const scrollDirection = useHeaderStore(state => state.scrollDirection);
    return (
        <div
            className={cn('fixed top-0 right-0 left-0 z-40 transition-transform duration-300', {
                'not-hover:-translate-y-full': scrollDirection === 'down',
                'translate-y-0': scrollDirection === 'up',
            })}>
            {children}
        </div>
    );
}
